import { useQuery, keepPreviousData } from "@tanstack/react-query";
import type { DateRangeOption } from "@/components/clicks/DateRangeFilter";
import type { UrlActiveFilters } from "@/lib/url-active-filters";
import { spySerpService } from "@/services/SpySerpService";
import { ensureSpyserpDateRange } from "@/hooks/spyserp/ensureSpyserpDateRange";

export interface SpyserpDomainStatsQueryKeyInput {
  page: number;
  pageSize: number;
  sortCol: string;
  sortDesc: boolean;
  filtersParam: string | null;
  activeFilters: UrlActiveFilters;
  dateRange: DateRangeOption;
  customFrom?: string;
  customTo?: string;
}

export const getSpyserpDomainStatsQueryKey = ({
  filtersParam,
  dateRange,
  customFrom,
  customTo,
  ...tableParams
}: SpyserpDomainStatsQueryKeyInput) =>
  [
    "spyserp",
    "domainStats",
    filtersParam,
    dateRange,
    customFrom ?? null,
    customTo ?? null,
    tableParams,
  ] as const;

export const useSpyserpDomainStats = (params: SpyserpDomainStatsQueryKeyInput) =>
  useQuery({
    queryKey: getSpyserpDomainStatsQueryKey(params),
    queryFn: async () => {
      const resolved = await ensureSpyserpDateRange({
        dateRange: params.dateRange,
        customFrom: params.customFrom,
        customTo: params.customTo,
      });
      return spySerpService.getDomainStats({
        page: params.page,
        pageSize: params.pageSize,
        sortCol: params.sortCol,
        sortDesc: params.sortDesc,
        activeFilters: params.activeFilters,
        startDate: resolved.startDate,
        endDate: resolved.endDate,
      });
    },
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5,
  });
